import { render, staticRenderFns } from "./ContactWidget.vue?vue&type=template&id=19d79ff8&scoped=true"
import script from "./ContactWidget.vue?vue&type=script&lang=js"
export * from "./ContactWidget.vue?vue&type=script&lang=js"
import style0 from "./ContactWidget.vue?vue&type=style&index=0&id=19d79ff8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d79ff8",
  null
  
)

export default component.exports